// @Version: 1.0.0
import { Injectable } from "@angular/core";
import { FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { FC_RATING } from "./rating.model";

@Injectable({
   providedIn: 'root'
})

export class CustomValidators {

   constructor () { }

   public isRequired (fg: FormGroup): ValidatorFn {
      return (): ValidationErrors | null => {
         return (!fg.value[FC_RATING.RATINGBUTTON] && String(fg.value[FC_RATING.RATINGBUTTON]) != "0") ? { required: true } : null
      }
   }
}
